import { PropTypes } from 'react';

export const itemsPropTypes = PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    disabled: PropTypes.bool
}));



// WEBPACK FOOTER //
// ./src/components/common/commonPropTypes.js